import { useState } from 'react'
import { Table, Input, Typography } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { useV20TfomsStyle } from '@/hooks/useNsiTfoms'
import type { V20TfomsStyleItem } from '@/api/nsiTfoms'

const { Text } = Typography
const { Search } = Input

export default function BedProfilesReadOnlyPage() {
  const { data, isLoading } = useV20TfomsStyle()
  const [search, setSearch] = useState('')
  const [pageSize, setPageSize] = useState(50)

  const items = (data?.items || []).filter((item) => {
    if (!search) return true
    const q = search.toLowerCase()
    return (
      String(item.idpk_tfoms).includes(q) ||
      (item.profil_k_tfoms_name || '').toLowerCase().includes(q) ||
      String(item.v020_code || '').includes(q) ||
      (item.v020_name || '').toLowerCase().includes(q)
    )
  })

  const columns: ColumnsType<V20TfomsStyleItem> = [
    {
      title: 'Код ТФОМС',
      dataIndex: 'idpk_tfoms',
      key: 'idpk_tfoms',
      width: 110,
      sorter: (a, b) => a.idpk_tfoms - b.idpk_tfoms,
      defaultSortOrder: 'ascend',
    },
    {
      title: 'Название ТФОМС',
      dataIndex: 'profil_k_tfoms_name',
      key: 'profil_k_tfoms_name',
      render: (text: string | null) => text || <Text type="secondary">-</Text>,
    },
    {
      title: 'Группа ТФОМС',
      dataIndex: 'tfoms_group_code',
      key: 'tfoms_group_code',
      width: 120,
      render: (code: number, record: V20TfomsStyleItem) =>
        code !== record.idpk_tfoms ? (
          <Text style={{ color: '#1677ff', fontWeight: 500 }}>{code}</Text>
        ) : code,
      sorter: (a: V20TfomsStyleItem, b: V20TfomsStyleItem) => a.tfoms_group_code - b.tfoms_group_code,
    },
    {
      title: 'Код V020',
      dataIndex: 'v020_code',
      key: 'v020_code',
      width: 110,
      render: (code: number | null) => code ?? <Text type="secondary">-</Text>,
    },
    {
      title: 'Название V020',
      dataIndex: 'v020_name',
      key: 'v020_name',
      render: (name: string | null) => name || <Text type="secondary">-</Text>,
    },
  ]

  return (
    <div>
      <Search
        placeholder="Поиск по коду или названию..."
        allowClear
        onChange={(e) => setSearch(e.target.value)}
        style={{ width: 400, marginBottom: 16 }}
      />

      <Table
        columns={columns}
        dataSource={items}
        rowKey="idpk_tfoms"
        loading={isLoading}
        size="small"
        pagination={{
          pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['20', '50', '100'],
          onShowSizeChange: (_, size) => setPageSize(size),
          showTotal: (total) => `Всего: ${total}`,
        }}
      />
    </div>
  )
}
